{
  "noAccessTitle": "No Access to AI Governance",
  "noAccessMessage": "You do not have permission to view workflows, policies, or agents. Contact your administrator to request access."
}
